import { useState } from "react"
import type { FC } from "react"
import { Heart, Bookmark } from "lucide-react"
import { useAppDispatch } from "@/app/hooks"
import { toggleLikePost } from "@/features/postDetail/postDetailSlice"

type InteractionButtonsProps = {
  postId: string
  liked: boolean
  likeCount: number
  scrapped?: boolean // API 미지원이지만 props로는 받아둠
}

const InteractionButtons: FC<InteractionButtonsProps> = ({
  postId,
  liked,
  likeCount,
}) => {
  const dispatch = useAppDispatch()
  const [showToast, setShowToast] = useState(false)

  const handleLike = () => {
    void dispatch(toggleLikePost(postId))
  }

  const handleScrap = () => {
    setShowToast(true)
    setTimeout(() => {
      setShowToast(false)
    }, 2000)
  }

  return (
    <div className="interaction-bar">
      <button
        onClick={handleLike}
        className={`interaction-btn ${liked ? "active" : "default"}`}
      >
        <Heart className={`w-5 h-5 ${liked ? "fill-current" : ""}`} />
        <span className="font-medium text-sm">좋아요 {likeCount}</span>
      </button>

      <button
        onClick={handleScrap}
        className="interaction-btn default"
      >
        <Bookmark className="w-5 h-5" />
        <span className="font-medium text-sm">저장</span>
      </button>

      {/* Simple Toast Implementation for this specific action if global Toast not available yet */}
      {showToast && (
         <div className="toast-message">
            준비 중인 기능입니다.
         </div>
      )}
    </div>
  )
}

export default InteractionButtons
